import { createSlice } from "@reduxjs/toolkit"


  const backdropSlice = createSlice({
    name: "backdrop",
    initialState: {
      show: false,
    },
    reducers: {
      toggleBackdrop(state,action){
          state.show=!state.show
      }
    },
  });
  
  export default backdropSlice
  
  export const backdropActions = backdropSlice.actions;